import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import OrderForm from 'forms/forms/OrderForm/index';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import { LinkButton, IconButton } from 'components/Button';
import Text from 'components/Text';
import Icon from 'components/Icon';
import Model from '../../../../../model';

import './index.sass';
import { whatsAppContacts } from 'components/AddressAndPhones';

const { block, el } = bem('order-form-modal');

const OrderFormModal = () => {

    const { modal, orderForm: { order } } = Model;
    const { isMobile } = useMobile();

    const handleClose = () => {
        modal.closeOrderForm();
    }

    const WAButton = isMobile ?
        <IconButton mod={'transparent'} name={'question-mark'} to={ whatsAppContacts.link } target={'_blank'} /> :
        <LinkButton mod={'transparent'} to={ whatsAppContacts.link } target={'_blank'}><Text>Нужна помощь?</Text></LinkButton>;

    return (
        <Dialog
            className={block()}
            open={ modal.isOrderFormOpen }
            onClose={ handleClose }
            fullWidth={ true }
            fullScreen={ isMobile }
            maxWidth={ 'md' }
            scroll={'body'}
            PaperProps={ {
                sx: {
                    maxWidth: 1024,
                    margin: '0 auto',
                    width: 1024,
                    borderRadius: isMobile ? 0 : '20px'
                }
            } }
        >
            { !order && <div className={el('header')}>
                <div className={el('title')}><Text>{'Запись\nна консультацию'}</Text></div>
                <div className={el('help-button')}>{WAButton}</div>
                <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
            </div> }
            <div className={el('content')}>
                <OrderForm/>
            </div>
        </Dialog>
    )
}

export default observer(OrderFormModal);
